// phoneUtils.ts
export interface CountryCode {
	code: string;
	prefix: string;
	flag: string;
	format: string;
	length: number;
}

export const COUNTRY_CODES: CountryCode[] = [
	{
		code: 'MX',
		prefix: '521',
		flag: '🇲🇽',
		format: 'XXXXXXXXXX',
		length: 10
	},
	{
		code: 'US',
		prefix: '1',
		flag: '🇺🇸',
		format: 'XXXXXXXXXX',
		length: 10
	},
	{
		code: 'CO',
		prefix: '57',
		flag: '🇨🇴',
		format: 'XXXXXXXXXX',
		length: 10
	}
];

export const formatPhoneNumber = (phone: string, countryCode: CountryCode): string => {
	return phone.replace(/\D/g, '').slice(0, countryCode.length);
};

export const extractBaseNumber = (phone: string, countryPrefix: string): string => {
	const cleaned = phone.replace(/\D/g, '');

	// Handle webhook format (extra '1' after country code in some cases)
	if (cleaned.startsWith(countryPrefix + '1')) {
		return cleaned.slice(countryPrefix.length + 1);
	}
	// Handle standard format
	if (cleaned.startsWith(countryPrefix)) {
		return cleaned.slice(countryPrefix.length);
	}

	return cleaned;
};
